export default {
  settingsSet: false,
  filters: [],
  activeFilters: {},
  search: '',
  currentPage: 1,
};
